import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Upload from "./pages/Upload";
import AdvancedUpload from "./pages/AdvancedUpload";
import FloorPlanEditor from "./pages/FloorPlanEditor";
import SmartEditor from "./pages/SmartEditor";
import Report from "./pages/Report";
import Marketplace from "./pages/Marketplace";
import Consultants from "./pages/Consultants";
import AIAssistant from "./pages/AIAssistant";
import Professionals from "./pages/Professionals";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import Questionnaire from "./pages/Questionnaire";
import Login from "./pages/Login";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  const location = useLocation();
  const isAdminWorkspace = location.pathname.startsWith("/admin");
  const isLoginPage = location.pathname === "/login";

  return (
    <div className={`App ${isAdminWorkspace ? "admin-workspace-mode" : ""}`}>
      {!isAdminWorkspace && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/advanced-upload" element={<AdvancedUpload />} />
        <Route path="/editor" element={<FloorPlanEditor />} />
        <Route path="/smart-editor" element={<SmartEditor />} />
        <Route path="/report/:id" element={<Report />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/marketplace/:id" element={<Marketplace />} />
        <Route path="/consultants" element={<Consultants />} />
        <Route path="/ai-assistant" element={<AIAssistant />} />
        <Route path="/professionals" element={<Professionals />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      {!isAdminWorkspace && !isLoginPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
